import { IActivityModel } from './Activity';
import { AuthHelper } from 'src/helpers/AuthHelper';
import { WebHelper } from 'src/helpers/WebHelper';
import { AxiosPromise } from 'axios';



// service 
export class ActivityService{
    public static getActivityById(detailkursusid: string) : AxiosPromise<IActivityModel> {
        try{
            
            const userToken = AuthHelper.GetUserToken();
            if(userToken === undefined || userToken === ''){
                throw Error("ActivityThemeService -getActivityThemes-> token not set");
            }
            WebHelper.Instance.headers = 
            { 
                'Authorization': "Bearer " + userToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-Client': 'application',
                'Pragma': 'no-cache',
                'Cache-Control': 'no-cache'
            }
            const webInstance = WebHelper.Instance.getAxiosInstance();            
            return webInstance.get('activity/GetCourseDetails/'+detailkursusid);
            
        } catch(e){
            throw e;
        }
    }


}


// WEBPACK FOOTER //
// ./src/Entities/Activity/Activity.Service.ts